






























import { Component, Prop, Vue } from 'vue-property-decorator';

import Game from '../../engine/Game';
import Room from '../../engine/Room';

@Component({
    components: {
    },
})
export default class RoomListVue extends Vue {

    @Prop() private game!: Game;

    changeRoom(room: Room){
        this.game.changeRoom(room);
        this.$emit('change');
    }


}

